module.exports = __webpack_public_path__ + "img/30_37.6dd4884b.png";